import type { PortfolioItem } from '@app/types';

export const LEGACY_GET_PORTFOLIO_ITEM = 'GET_PORTFOLIO_ITEM';
export const FETCH_PORTFOLIO_ITEM = 'iron/portfolio-item/FETCH_PORTFOLIO_ITEM';
export const SET_PORTFOLIO_ITEM = 'iron/portfolio-item/SET_PORTFOLIO_ITEM';
export const SET_PORTFOLIO_ITEM_ERROR =
  'iron/portfolioItem/SET_PORTFOLIO_ITEM_ERROR';
export const SET_NEW_PORTFOLIO_ITEM =
  'iron/portfolioItem/SET_NEW_PORTFOLIO_ITEM';
export const CLEAR_NEW_PORTFOLIO_ITEM =
  'iron/portfolioItem/CLEAR_NEW_PORTFOLIO_ITEM';
export const ADD_PORTFOLIO_ITEM = 'iron/portfolioItem/ADD_PORTFOLIO_ITEM';
export const SUBMIT_BID = 'iron/portfolioItem/SUBMIT_BID';
export const SUBMIT_ASK = 'iron/portfolioItem/SUBMIT_ASK';
export const DELETE_PORTFOLIO_ITEM = 'iron/portfolioItem/DELETE_PORTFOLIO_ITEM';
export const SET_LAST_CLICKED_PORTFOLIO_ITEM =
  'iron/portfolioItem/SET_LAST_CLICKED_PORTFOLIO_ITEM';
export const TRACK_PORTFOLIO_ITEM = 'iron/portfolio-item/TRACK_PORTFOLIO_ITEM';

export const fetchPortfolioItem = ({ chainId, params }) => ({
  type: FETCH_PORTFOLIO_ITEM,
  payload: {
    chainId,
    params,
  },
});

export const setPortfolioItem = (portfolioItem) => ({
  type: SET_PORTFOLIO_ITEM,
  payload: { portfolioItem },
});

export const submitBid = ({
  data = {},
  customer = {},
  product = {},
  paymentMethod = '',
  isGlobalNotificationEmailEnabled = false,
} = {}) => ({
  type: SUBMIT_BID,
  payload: {
    action: 'bid',
    data,
    customer,
    paymentMethod,
    product,
    isGlobalNotificationEmailEnabled,
  },
});

export const submitAsk = ({ data = {}, customer = {}, item = {} } = {}) => ({
  type: SUBMIT_ASK,
  payload: {
    action: 'ask',
    data,
    customer,
    item,
  },
});

export const setPortfolioItemError = (error) => ({
  type: SET_PORTFOLIO_ITEM_ERROR,
  payload: {
    error,
  },
});

export const setNewPortfolioItem = (newPortfolioItem: PortfolioItem) => ({
  type: SET_NEW_PORTFOLIO_ITEM,
  payload: {
    newPortfolioItem,
  },
});

export const clearNewPortfolioItem = () => ({
  type: CLEAR_NEW_PORTFOLIO_ITEM,
});

export const addPortfolioItem = (portfolioItem) => ({
  type: ADD_PORTFOLIO_ITEM,
  payload: {
    portfolioItem,
  },
});

export const deletePortfolioItem = (payload) => ({
  type: DELETE_PORTFOLIO_ITEM,
  payload,
});

export const setLastClickedPortfolioItem = (lastClickedPortfolioItem) => ({
  type: SET_LAST_CLICKED_PORTFOLIO_ITEM,
  payload: { lastClickedPortfolioItem },
});

export const trackPortfolioItem = (payload) => ({
  type: TRACK_PORTFOLIO_ITEM,
  payload,
});
